import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { type ApiError } from 'openapi-typescript-fetch'

export const usePostPatronBadgeReward = ({
  patronId,
  onError,
  onSuccess,
}: {
  patronId: number
  badgeRewardId: number
  onSuccess?: () => Promise<void> | void
  onError?: (error: ApiError) => void
}) => {
  const qc = useQueryClient()
  const post = useTypedApiClient({
    path: '/admin/patronbadgerewards',
    method: 'post',
  })

  return useMutation({
    mutationFn: async ({
      patronId,
      badgeRewardId,
    }: {
      patronId: number
      badgeRewardId: number
    }) => {
      const { data } = await post({
        patronId,
        badgeRewardId,
      })
      return data
    },
    onSuccess: async () => {
      await qc.invalidateQueries({
        queryKey: ['/admin/patronaccount/detail', patronId],
      })
      await qc.invalidateQueries({
        queryKey: ['/admin/patronbadgerewards/patron/{id}', patronId],
      })
      await qc.invalidateQueries({
        queryKey: ['/admin/badgerewards'],
      })

      await onSuccess?.()
    },
    onError,
  })
}
